import React from "react";
import {
    DatePicker
} from "antd";
import PropTypes from "prop-types";

class DatePickerEditor extends React.Component {
    // value = this.props.defaultValue;
    // onSelect = (value) => {
    //     this.value = value;
    // }
    // componentWillUnmount() {
    //     this.props.onCommit(this.value);
    // }

    render() {
        return (
            <div className={"date-picker-parent"}>
                {React.createElement(
                    DatePicker, {
                        placeholder: this.props.placeholder,
                        prefix: this.props.prefix,
                        format: this.props.dateFormat,
                        disabledDate: this.props.disabledDate,
                        disabled: this.props.disabled,
                        size: this.props.size || "default",
                        getCalendarContainer: () => document.getElementsByClassName("date-picker-parent")[0],
                        ...(this.props.mode ? { mode: this.props.mode } : {})
                    }
                    
                )}
            </div>
        );
    }
}

DatePickerEditor.propTypes = {
    defaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    mode: PropTypes.string,
    onCommit: PropTypes.func,
    disabled: PropTypes.string,
    size: PropTypes.string,
    prefix: PropTypes.string,
    options: PropTypes.object,
    dateFormat: PropTypes.string,
    disabledDate: PropTypes.bool
};

export default DatePickerEditor;